import { ChangeDetectorRef, Component, Inject, NgZone, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DatatableCompatDirective } from 'src/app/shared/datatables-compat/datatable-compat.module';
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { seguimientosRiesgos } from "src/app/shared/model/gestion-proyectos/seguimientoRiesgo";
import { ProyectosService } from "../../proyectos.service";
import swal from "sweetalert2";
import { Riesgos } from "src/app/shared/model/gestion-proyectos/riesgos/riesgo.model";
import { Probabilidad } from "src/app/shared/model/gestion-proyectos/riesgos/probabilidad.model";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";
import { Impacto } from "src/app/shared/model/gestion-proyectos/riesgos/impacto.model";
import { SeveridadRiesgo } from "src/app/shared/model/gestion-proyectos/riesgos/severidad-riesgo.model";
import { Config } from "datatables.net";

// Angular core y formularios
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

// Angular Material
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";

// Módulo de búsqueda dentro de mat-select
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";

// DataTables para Angular
import { DatatableCompatModule } from 'src/app/shared/datatables-compat/datatable-compat.module';

@Component({
  selector: "app-modal-seguimiento-riesgo",
  templateUrl: "./modal-seguimiento-riesgo.component.html",
  styleUrls: ["./modal-seguimiento-riesgo.component.css"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMatSelectSearchModule,
    DatatableCompatModule,
  ],
})
export class ModalSeguimientoRiesgoComponent implements OnInit {
  @ViewChild(DatatableCompatDirective)
  dataElement: DatatableCompatDirective;
  listaSeguimiento: Array<seguimientosRiesgos> = [];
  lseguimiento: seguimientosRiesgos;
  dt: Config = {};
  shed = new ConsultaList<seguimientosRiesgos>();
  tablaseguimientosRiesgoss: Array<seguimientosRiesgos>;
  totalRegistros: number;
  agregarSeguimientoBtn: boolean;
  estatusRiesgo: boolean = false;
  riesgoCerrado: boolean = false;
  probabilidad: Probabilidad[] = [];
  impacto: Impacto[] = [];
  severidad: SeveridadRiesgo[] = [];
  objetoSeguimiento: seguimientosRiesgos = new seguimientosRiesgos();
  riesgo: Riesgos;

  constructor(
    public dialogRef: MatDialogRef<ModalSeguimientoRiesgoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private proyectoService: ProyectosService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.shed.bean = new seguimientosRiesgos();
    this.riesgo = this.data.riesgo;
    this.dt = {
      pageLength: 10,
      language: {
        zeroRecords: " ",
      },
      serverSide: true,
      ajax: (dataTablesParameters: any, callback) => {
        this.shed.regInicial = dataTablesParameters.start;
        this.shed.regXPagina = dataTablesParameters.length;
        this.shed.bean.id_riesgo = this.riesgo.id;

        this.proyectoService.conultaSeguimientos(this.shed).subscribe((res) => {
          this.ngZone.run(() => {
            if (res.pCodRetorno === "00000") {
              this.totalRegistros = res.pTotalItems;
              this.listaSeguimiento = res.list ?? [];
              callback({
                recordsTotal: this.totalRegistros,
                recordsFiltered: this.totalRegistros,
                data: [],
              });
              this.cdr.detectChanges();
            }
          });
        });
      },
    };
    this.obtenerProbabilidad();
    this.obtenerImpactos();
    this.obtenerSeveridad();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  agregarSeguimiento() {
    this.agregarSeguimientoBtn = true;
  }

  cancelarSeguimiento() {
    this.agregarSeguimientoBtn = false;
  }

  save(): void {
    this.objetoSeguimiento.id_riesgo = this.riesgo.id;
    this.objetoSeguimiento.estatusRiesgo = this.estatusRiesgo;
    this.proyectoService
      .guardarSeguimientoRiesgo(this.objetoSeguimiento)
      .subscribe(
        (respuesta: any) => {
          if (respuesta) {
            swal
              .fire({
                text: "Seguimiento registrado exitosamente",
                buttonsStyling: false,
                customClass: {
                  confirmButton: "btn btn-success",
                  cancelButton: "btn btn-danger",
                },
                icon: "success",
              })
              .then((result) => {
                this.guardaActualizaRiesgo();
                if (result.isConfirmed) {
                  this.dialogRef.close();
                }
              });
          } else {
            console.error(
              "La respuesta del servicio de seguimiento no es válida :c",
              respuesta
            );
          }
        },
        (error) => {
          console.error("Error al guardar el seguimiento :c", error);

          swal.fire({
            text: "Ocurrió un error al guardar el seguimiento",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-danger",
            },
            icon: "error",
          });
        }
      );
  }

  guardaActualizaRiesgo() {
    this.riesgo.estatus = this.estatusRiesgo;
    this.proyectoService.guardaRiesgo(this.riesgo).subscribe((res) => {});
  }

  obtenerProbabilidad() {
    this.proyectoService
      .consultaGeneral(UrlConstantes.consultaProbabilidad)
      .subscribe((res) => {
        if (res != null) {
          this.probabilidad = res.list;
        }
      });
  }

  obtenerImpactos() {
    this.proyectoService
      .consultaGeneral(UrlConstantes.consultaImpactos)
      .subscribe((res) => {
        if (res != null) {
          this.impacto = res.list;
        }
      });
  }

  obtenerSeveridad() {
    this.proyectoService
      .consultaGeneral(UrlConstantes.consultaSeveridad)
      .subscribe((res) => {
        if (res != null) {
          this.severidad = res.list;
        }
      });
  }
}
